var map = {
	"./about-us.svg": 602,
	"./betting-icon.svg": 603,
	"./bonus.svg": 604,
	"./coin.png": 605,
	"./contact-us.svg": 606,
	"./download-app.svg": 607,
	"./edit-btn.svg": 608,
	"./feedback.svg": 609,
	"./global.svg": 610,
	"./info-centre.svg": 611,
	"./mall-icon.svg": 612,
	"./message.svg": 613,
	"./redemption-icon.svg": 614,
	"./referral.svg": 615,
	"./resp-gaming.svg": 616,
	"./security.svg": 617,
	"./transaction-icon.svg": 618,
	"./vip-icon.svg": 619,
	"./wallet-icon.svg": 620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2290;